"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadMore = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LoadMore = ({
  onClick,
  isLoading
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Button, {
      fullWidth: isMobile,
      maxWidth: isMobile ? '500px' : undefined,
      "data-testid": getTestId(_constants.LOAD_BUTTON),
      variant: "outlined",
      loading: isLoading,
      onClick: onClick,
      children: translations.loadMore
    })
  });
};
exports.LoadMore = LoadMore;
